import Joi from 'joi';

const arrayOfEmails = Joi.array().items(
  Joi.string()
    .email({ tlds: false })
    .lowercase()
    .trim()
    .messages({ '*': 'email_client.fields.wrong_email' }),
);

const emailShadow = Joi.string()
  .lowercase()
  .trim()
  .email({ tlds: false })
  .allow('')
  .messages({ '*': 'email_client.fields.wrong_email' });

export const commonEmailValidationSchema = Joi.object({
  to: arrayOfEmails
    .min(1)
    .required()
    .messages({ '*': 'email_client.fields.one_or_more_emails' }),
  cc: arrayOfEmails,
  bcc: arrayOfEmails,
  subject: Joi.string()
    .trim()
    .required()
    .messages({ '*': 'email_client.field.subject.required' }),
  to_draft: emailShadow,
  cc_draft: emailShadow,
  bcc_draft: emailShadow,
});

const attachmentsCombinedSchema = Joi.object({
  allAttachments: Joi.array()
    .items(
      Joi.string(),
      Joi.object({
        filePath: Joi.string().required(),
        name: Joi.string().required(),
      }),
    )
    .min(1)
    .required(),
});

export const revenueEmailValidationSchema = commonEmailValidationSchema.concat(
  attachmentsCombinedSchema,
);

export const quoteEmailValidationSchema = commonEmailValidationSchema;

export const recurringRevenueValidationSchema = attachmentsCombinedSchema;
